<template>
  <div class="container">
    <a-breadcrumb class="breadcrumb">
      <a-breadcrumb-item class="black">{{
        t("customermanagement")
      }}</a-breadcrumb-item>
      <a-breadcrumb-item class="black">
        <router-link :to="`${routerName.customerList}`">{{
          t("customerlist")
        }}</router-link>
      </a-breadcrumb-item>
      <a-breadcrumb-item class="currentrouter">{{
        t("vehiclemanagement")
      }}</a-breadcrumb-item>
    </a-breadcrumb>
    <div class="search-input-group">
      <a-input
        style="width: 15%"
        v-model:value="stationParam.vin"
        :placeholder="t('supportvinsearch')"
      />
      <a-button
        type="primary"
        class="searchBtn"
        @click="search"
        :disabled="isadd"
        >{{ t("search") }}</a-button
      >
      <a-button
        type="primary"
        class="searchBtn addBtn"
        @click="addStation"
        :disabled="isadd"
        >{{ t("add") }}</a-button
      >
      <a-button
        type="primary"
        class="searchBtn addBtn"
        @click="showModal(1)"
        :disabled="isadd"
        >{{ t("batchdelete") }}</a-button
      >
    </div>
    <a-table
      :data-source="carList"
      :columns="columns"
      :pagination="false"
      :scroll="{ y: maxHeight }"
      :row-selection="rowSelection"
    >
      <template #bodyCell="{ text, record, index, column }">
        <template v-if="column.dataIndex === 'index'">
          <div>{{ index + 1 }}</div>
        </template>
        <template v-else-if="['vin'].includes(column.dataIndex)">
          <div>
            <a-select
              v-if="isadd && index === 0"
              v-model:value="addNewVehicle"
              style="width: 90%; margin: -5px 0"
              showSearch
              :filter-option="filterOption"
            >
              <a-select-option
                v-for="item in vinsList"
                :key="item.vin"
                v-model:value="item.vin"
                :disabled="item.disable"
              >
                <span style="float: left">{{ item.vin }}</span>
                <span style="float: right; font-size: 13px">{{
                  item.orgName
                }}</span></a-select-option
              >
            </a-select>
            <div v-else>{{ text }}</div>
          </div>
        </template>
        <template v-else-if="column.dataIndex === 'car_model'">
          <div class="operate">
            <a-dropdown :trigger="['click']">
              <a class="ant-dropdown-link" @click="checkItem(record)">
                <img
                  v-if="record.id !== checkedId"
                  src="../assets/images/notclicked.png"
                  alt=""
                />
                <img v-else src="../assets/images/clicked.png" alt="" />
              </a>
              <template #overlay>
                <a-menu>
                  <a-menu-item
                    v-if="isadd && index == 0"
                    key="0"
                    @click="save(record)"
                  >
                    {{ t("save") }}</a-menu-item
                  ><a-menu-divider />
                  <a-menu-item
                    key="1"
                    v-if="isadd && index == 0"
                    @click="cancel(record.id)"
                    >{{ t("cancellation") }}</a-menu-item
                  >
                  <a-menu-item
                    v-if="!(isadd && index == 0)"
                    key="2"
                    @click="detail"
                    >{{ t("details") }}</a-menu-item
                  >
                  <a-menu-divider />
                  <a-menu-item
                    v-if="!(isadd && index == 0)"
                    key="3"
                    :disabled="isadd"
                    @click="showModal(2, record.vin)"
                  >
                    {{ t("delete") }}
                  </a-menu-item>
                </a-menu>
              </template>
            </a-dropdown>
          </div>
        </template>
      </template>
    </a-table>
    <a-pagination
      class="pagination"
      show-size-changer
      show-quick-jumper
      :show-total="(totalNum) => `${t('intotal')} ${totalNum} ${t('article')}`"
      v-model:current="stationParam.page"
      v-model:pageSize="stationParam.size"
      :total="totalNum * 1"
      size="small"
      @change="handlePaginationChange"
    />
  </div>
  <a-modal
    v-model:open="open"
    :title="t('tips')"
    @ok="handleOk"
    :closable="false"
  >
    <template #footer>
      <a-button key="back" @click="open = false">{{
        t("cancellation")
      }}</a-button>
      <a-button key="submit" type="primary" @click="handleOk">{{
        t("determine")
      }}</a-button>
    </template>
    <div
      style="
        height: 100px;
        line-height: 50px;
        border-top: 1px solid #eaeaea;
        border-bottom: 1px solid #eaeaea;
      "
    >
      <span
        role="img"
        aria-label="exclamation-circle"
        class="anticon anticon-exclamation-circle"
        style="color: #feb300"
        ><svg
          focusable="false"
          class=""
          data-icon="exclamation-circle"
          width="1em"
          height="1em"
          fill="currentColor"
          aria-hidden="true"
          viewBox="64 64 896 896"
        >
          <path
            d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-32 232c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V296zm32 440a48.01 48.01 0 010-96 48.01 48.01 0 010 96z"
          ></path></svg
      ></span>
      {{ t("areyousure") }}{{ buttonType === 1 ? t("batchdelete") : t("delete")
      }}{{ t("selecteddata") }}？
    </div>
  </a-modal>
</template>
<script>
import Api from "@/api/userService";
import { ref, onMounted, computed } from "vue";
import { message } from "ant-design-vue";
import { useRoute, useRouter } from "vue-router";
import ResultCodeType from "@/constant/ResultCodeType";
import { useStore } from "vuex";
import routerName from "@/router/routerName";
import { useI18n } from "vue-i18n";

export default {
  name: "VehicleManagement",
  setup() {
    const { t } = useI18n();

    const store = useStore();
    const maxHeight = computed(() => store.getters.getMaxHeight);
    const route = useRoute();
    const router = useRouter();
    const id = route.query.id;
    //新增列表
    const addData = ref({});
    //正在添加
    const isadd = ref(false);
    const stationParam = ref({
      id: id,
      vin: "",
      page: 1,
      size: 20,
    });
    //新增
    const addStation = () => {
      isadd.value = true;
      addData.value = {
        vin: "",
        vehicle_name: "",
        category_name: "",
      };
      carList.value.unshift(addData.value);
    };
    //详情
    const detail = () => {
      router.push({
        path: routerName.basicInfo,
        query: { vin: checkedId.value, category_id: category_id.value },
      });
    };
    const addVehicleForm = ref({
      orgId: Number(id),
      vins: [],
    });
    //保存
    const addNewVehicle = ref("");
    const save = () => {
      addVehicleForm.value.vins = [];
      addVehicleForm.value.vins.push(addNewVehicle.value);
      Api.reserveCarClient(addVehicleForm.value)
        .then((val) => {
          if (val.err_no == ResultCodeType.success_200) {
            message.success(t("savetime"));
            isadd.value = false;
            addNewVehicle.value = "";
            getListData();
            getVinList();
          } else {
            message.error(t("pleasetryagain"));
          }
        })
        .catch(() => {
          message.error(t("pleasetryagain"));
        });
    };
    //取消
    const cancel = () => {
      isadd.value = false;
      addNewVehicle.value = "";
      carList.value.shift();
    };
    const delVehicle = (value) => {
      const param = {
        orgId: id,
        vins: [],
      };
      if (checkedList.value.length > 0) {
        param.vins = checkedList.value;
      } else if (value) {
        param.vins.push(value);
      }
      Api.removeCarClient(param)
        .then((val) => {
          if (val.err_no == ResultCodeType.success_200) {
            checkedList.value = [];
            message.success(t("successfullydeleted"));
            getVinList();
            getListData();
          } else {
            message.error(val.err_msg);
          }
        })
        .finally(() => {
          open.value = false;
        });
    };
    const handlePaginationChange = (page, pageSize) => {
      stationParam.value.page = page;
      stationParam.value.size = pageSize;
      getListData();
    };
    const carList = ref();
    const totalNum = ref(0);
    const getListData = () => {
      Api.getVehicleManagementList(stationParam.value).then((val) => {
        if (val.err_no === ResultCodeType.success_200) {
          if (val.result.length > 0) {
            carList.value = val.result.map((item) => {
              return {
                ...item,
                key: item.vin,
              };
            });
          }
          totalNum.value = val.total_num;
        } else {
          carList.value = [];
          message.error(val.err_msg);
        }
      });
    };
    const search = () => {
      stationParam.value.page = 1;
      getListData();
    };
    const checkedList = ref([]);
    const rowSelection = {
      onChange: (selectedRowKeys) => {
        checkedList.value = selectedRowKeys;
      },
    };
    const vinsList = ref([]);
    const getVinList = () => {
      Api.getVehicleManagementVINList().then((result) => {
        vinsList.value = result.result;
      });
    };
    const filterOption = (input, option) => {
      return option.value.indexOf(input) >= 0;
    };
    const columns = [
      {
        title: "VIN",
        dataIndex: "vin",
        key: "vin",
        width: "35%",
        align: "center",
      },
      {
        title: t("vehicletype"),
        dataIndex: "category_name",
        key: "category_name",
        width: "25%",
        align: "center",
      },
      {
        title: t("vehiclename"),
        dataIndex: "vehicle_name",
        key: "vehicle_name",
        width: "25%",
        align: "center",
      },
      {
        title: t("operate"),
        dataIndex: "car_model",
        key: "car_model",
        width: "15%",
        align: "center",
      },
    ];
    const checkedId = ref("");
    const category_id = ref("");
    const checkItem = (value) => {
      checkedId.value = value.vin;
      category_id.value = value.category_id;
    };

    const open = ref(false);
    const beDeletedId = ref("");
    const buttonType = ref(1);
    const showModal = (type, vin) => {
      if (type === 1 && checkedList.value.length === 0) {
        message.error(t("novehicleselected"));
        return;
      }
      buttonType.value = type;
      beDeletedId.value = vin;
      open.value = true;
    };

    const handleOk = () => {
      if (buttonType.value === 1) {
        delVehicle();
      } else {
        delVehicle(beDeletedId.value);
      }
    };

    onMounted(() => {
      getListData();
      getVinList();
    });
    return {
      buttonType,
      showModal,
      open,
      handleOk,
      checkedId,
      checkItem,
      carList,
      rowSelection,
      columns,
      stationParam,
      handlePaginationChange,
      getListData,
      totalNum,
      detail,
      save,
      cancel,
      addStation,
      isadd,
      delVehicle,
      addData,
      addNewVehicle,
      vinsList,
      filterOption,
      search,
      maxHeight,
      routerName,
      t,
    };
  },
};
</script>
<style scoped></style>
